import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useTranslation } from "react-i18next";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { clearCart } from "../../Components/redux/cartItemsSlice";
import { toast } from "react-toastify";
import { v4 as uuidv4 } from "uuid";

const Orders = () => {
  const { t, i18n } = useTranslation();
  const currentLanguage = i18n.language;
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const cartItems = useSelector((state) => state.cartItems.items);
  const locations = useSelector((state) => state.locations.items);
  const selectedLocationId = useSelector(
    (state) => state.locations.selectedLocationId
  );

  const uid = useSelector((state) => state.user.id);

  const [products, setProducts] = useState([]);
  const [paymentMethod, setPaymentMethod] = useState("online"); // default online
  const [productsWithName, setProductsWithName] = useState([]);
  

  useEffect(() => {
    const fetchProducts = async () => {
      try {
        const responses = await Promise.all(
          cartItems.map((item) =>
            axios.get(
              `https://www.elzabeauty.az/elza/dashboard.php?id=${item.product_id}`
            )
          )
        );

        const newArray = responses.map((res, index) => {
          const productData = res.data?.data?.[0];
          return {
            ...cartItems[index],
            name: productData?.name || "Bilinməyən məhsul",
            image: productData?.image1 || null,
            price: productData?.secondPrice || productData?.firstPrice || 0,
          };
        });

        setProductsWithName(newArray);
      } catch (error) {
        console.error("Ürünlər alınarkən xəta baş verdi:", error);
      }
    };

    fetchProducts();
  }, [cartItems]);

  useEffect(() => {
    const fetchProducts = async () => {
      const res = await axios.get(
        "https://www.elzabeauty.az/elza/dashboard.php"
      );
      setProducts(res.data.data || []);
    };
    fetchProducts();
  }, []);

  const getProductById = (id) => products.find((p) => p.id == id);
  const selectedLocation = locations.find(
    (loc) => loc.id === selectedLocationId
  );

  const orderPrice = cartItems.reduce((total, item) => {
    const product = getProductById(item.product_id);
    if (!product) return total;
    const price = parseFloat(product.secondPrice || product.firstPrice || 0);
    return total + price * item.quantity;
  }, 0);

  const location = locations.find((item) => item.id === selectedLocationId);

  const deliveryPrice =
    orderPrice > 100
      ? 0
      : orderPrice > 60 &&
        ["Metrolar", "Poçt", "Şəhərdaxili"].includes(location.deliveryLocation)
      ? 0
      : location.deliveryPrice;

  const totalPrice = orderPrice + deliveryPrice;

  const handleCompleteOrder = async () => {

    if (
  selectedLocation.deliveryLocation === "Poçt" &&
  paymentMethod === "cash"
) {
  toast.error(t("Poçt çatdırılmasında nağd ödəniş mümkün deyil"));
  setPaymentMethod("online");
  return;
}

  console.log(paymentMethod);
  if (!uid || !selectedLocation || cartItems.length === 0) {
    alert(t("Məlumatlar natamamdır"));
    return;
  }

  const order_uid = uuidv4();

  try {
    // ✅ Statusu cash üçün 'cash', onlayn ödəniş üçün 'pending'
    const statusValue = paymentMethod === "cash" ? "cash" : "pending";

    const orderRes = await axios.post(
      "https://www.elzabeauty.az/elza/orders.php",
      {
        user_id: uid,
        location: selectedLocation.address,
        products: cartItems,
        total_price: orderPrice.toFixed(2),
        delivery_price: deliveryPrice.toFixed(2),
        delivery_location: selectedLocation.deliveryLocation,
        order_uid,
        status: statusValue,
        payment_type: paymentMethod,
      }
    );

    const orderId = orderRes.data?.data?.id;
    if (!orderId) {
      toast.error(t("Sifariş yaradılmadı"));
      return;
    }

    dispatch(clearCart());

    // ✅ Formspree bildirimi
    try {
      await fetch("https://formspree.io/f/xrbyevrj", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
        body: JSON.stringify({
          subject: `Yeni Sifariş – #${order_uid} (${paymentMethod})`,
          message: `
Sifariş ID: ${orderId}
UID: ${uid}
Ümumi məbləğ: ${totalPrice.toFixed(2)} ₼
Ödəniş növü: ${paymentMethod}
Ünvan: ${selectedLocation.name}, ${selectedLocation.city}, ${selectedLocation.address}
Seçilən çatdırılma regionu: ${selectedLocation.deliveryLocation}
Telefon: ${selectedLocation.mobile}
Məhsullar: ${productsWithName
            .map((it) => `${it.name || it.product_id} - ${it.quantity} ədəd`)
            .join(", ")}
      `,
        }),
      });
    } catch (mailErr) {
      console.error("Formspree xətası:", mailErr);
    }

    if (paymentMethod === "cash") {
      toast.success(t("Sifarişiniz uğurla qeydə alındı"));
      navigate(`/${currentLanguage}/orders/thank-you`);
      return;
    }

    // ✅ Onlayn ödəniş üçün
    const response = await axios.post(
      "https://www.elzabeauty.az/elza/create-payment.php",
      new URLSearchParams({
        amount: totalPrice.toFixed(2),
        user_id: uid,
        location: JSON.stringify(selectedLocation), 
        products: JSON.stringify(cartItems),
        order_id: orderId,
        order_uid,
      })
    );

    if (response.data?.status === "success" && response.data?.redirect_url) {
      window.location.href = response.data.redirect_url;
    } else {
      console.error("Ödəniş səhifəsinə keçid alınmadı:", response?.data);
      alert(t("Ödənişə keçid zamanı xəta baş verdi"));
    }
  } catch (err) {
    console.error("Sifariş xətası:", err);
    alert(t("Server xətası baş verdi"));
  }
};

const isPostDelivery =
  selectedLocation?.deliveryLocation === "Poçt";



  if (!selectedLocation) {
    return (
      <div className="text-center py-20 text-lg text-red-600">
        {t("Zəhmət olmasa ünvan seçin.")}
      </div>
    );
  }

  return (
    <>
      <div className="max-w-containerSm md:max-w-container mx-auto py-10 md:py-20">
        <div className="md:flex justify-between">
          <div className="md:w-[695px] mb-10 md:mb-0">
            {/* Add radio buttons for payment type */}
            <div className="mt-6 space-y-4">
              <p className="text-[20px] font-medium text-firstColor">
                {t("Ödəniş növü")}
              </p>
              <label className="flex items-center gap-2">
                <input
                  type="radio"
                  name="payment"
                  value="online"
                  checked={paymentMethod === "online"}
                  onChange={(e) => setPaymentMethod(e.target.value)}
                />
                {t("Onlayn ödəniş")}
              </label>
              {!isPostDelivery && (
  <label className="flex items-center gap-2">
    <input
      type="radio"
      name="payment"
      value="cash"
      checked={paymentMethod === "cash"}
      onChange={(e) => setPaymentMethod(e.target.value)}
    />
    {t("Nağd ödəniş")}
  </label>
)}

            </div>

            {/* Mövcud sifariş məlumatları */}
            <div className="w-full mt-10 md:mt-20">
              <h2 className="text-[20px] md:text-[24px] font-medium text-firstColor">
                {t("Sifariş məlumatları")}
              </h2>
              <div className="mt-6 md:mt-10 text-[16px] text-secondColor space-y-3">
                <p>{selectedLocation.name}</p>
                <p>{selectedLocation.city} şəhəri</p>
                <p>{selectedLocation.address}</p>
                <p>{selectedLocation.mobile}</p>
                <p>
                  {selectedLocation.deliveryLocation} ({t("Çatdırılma ünvanı")})
                </p>
              </div>
              <div className="mt-10">
                <button
                  onClick={handleCompleteOrder}
                  className="bg-[#181D27] text-white w-full md:w-[323px] rounded-lg h-[52px]"
                >
                  {t("Təsdiqlə")}
                </button>
              </div>
            </div>
          </div>

          <div className="md:w-[505px] mt-10 md:mt-0 border border-[#E2E2E2] rounded-[20px] p-5 max-h-[350px]">
            <p className="text-[#181D27] text-[20px] md:text-[24px] font-semibold">
              {t("Ümumi")}
            </p>
            <div className="h-[1px] w-full bg-[#E2E2E2] my-5"></div>
            <div className="flex justify-between">
              <p className="text-[18px] md:text-[20px] font-medium text-[#181D27]">
                {t("Qiymət")}:
              </p>
              <p className="text-[18px] md:text-[20px] font-medium text-[#181D27]">
                {orderPrice.toFixed(2)} ₼
              </p>
            </div>
            <div className="flex justify-between mt-4">
              <p className="text-[18px] md:text-[20px] font-medium text-[#181D27]">
                {t("Çatdırılma")}:
              </p>
              <p className="text-[18px] md:text-[20px] font-medium text-[#181D27]">
                {deliveryPrice.toFixed(2)} ₼
              </p>
            </div>
            <div className="flex justify-between mt-4">
              <p className="text-[18px] md:text-[20px] font-medium text-[#181D27]">
                {t("Ümumi")}:
              </p>
              <p className="text-[18px] md:text-[20px] font-medium text-[#181D27]">
                {totalPrice.toFixed(2)} ₼
              </p>
            </div>
            <p className="mt-6 text-[14px] text-gray-600">
              {t(
                "60 AZN-Dən yuxarı sifarişlərdə metro, poçt və şəhərdaxili çatdırılma, 100 AZN-dən yuxarı sifarişlərdə isə bütün çatdırılmalar ödənişsizdir."
              )}
            </p>
          </div>
        </div>
      </div>
    </>
  );
};

export default Orders;
